<template>
  <div>
    <table-pagination class="mb-1" :pagination="pagination" :counter-label="$t('backup.tabs.log')"
                      @page-change="onPaginationPage" @size-change="onPaginationSize"/>

    <b-table responsive class="bk-table" :items="rows" :fields="fields"
             no-local-sorting :sort-by="sort.field" :sort-desc="sortIsDesc"
             :busy="loading" hover show-empty
             @sort-changed="onSortChanged">
      <template #table-busy>
        <div class="text-center text-primary my-2"><b-spinner small class="mr-50"/>{{ $t('backup.loading') }}</div>
      </template>
      <template #empty>
        <backup-table-state :error="loadError ? errorText() : null" icon="fa-solid fa-clock-rotate-left"
                            :title="$t('backup.emptyLog')" :hint="$t('backup.emptyLogHint')" @retry="refresh"/>
      </template>

      <template #cell(time)="{ value }">{{ bkDateTime(value) }}</template>
      <template #cell(userId)="{ value }">
        <div v-if="value" class="d-flex align-items-center">
          <b-avatar size="22" variant="light-primary" class="mr-50" :text="getUserAcronyms(value)"/>
          <span>{{ bkUserName(value) }}</span>
        </div>
        <span v-else class="text-muted">—</span>
      </template>
      <template #cell(kind)="{ value }">
        <span class="bk-kind"><i :class="kindIcon(value)"></i>{{ bkT(`backup.kind.${value}`, value) }}</span>
      </template>
      <template #cell(backupId)="{ item }">
        <span class="bk-id">#{{ item.backupId }}</span>
        <span v-if="item.currentId" class="bk-id bk-id--current"> → #{{ item.currentId }}</span>
      </template>
      <template #cell(clientId)="{ value }">
        <a v-if="value" href="#" class="bk-id bk-id--current" @click.prevent="showClient(value)">
          <i class="fa-solid fa-arrow-up-right-from-square mr-25"></i>#{{ value }}
        </a>
        <span v-else class="text-muted">—</span>
      </template>
      <template #cell(options)="{ value }">
        <template v-if="value && typeof value === 'object'">
          <span v-if="value.applyToBalance === true" class="bk-tag bk-tag--balance">
            <i class="fa-solid fa-scale-unbalanced mr-25"></i>{{ $t('backup.balanceOn') }}
          </span>
          <span v-else-if="value.applyToBalance === false" class="bk-tag">{{ $t('backup.recordOnly') }}</span>
          <span v-for="(v, k) in otherOptions(value)" :key="k" class="bk-tag">{{ k }}: {{ v }}</span>
        </template>
        <span v-else-if="value" class="bk-tag">{{ value }}</span>
      </template>
      <template #cell(result)="{ value }">
        <span class="bk-result" :class="`bk-result--${(value || '').toLowerCase()}`">{{ bkT(`backup.result.${value}`, value) }}</span>
      </template>
      <template #cell(message)="{ value }"><span class="bk-msg" :title="value">{{ value }}</span></template>
    </b-table>

    <table-pagination v-if="rows.length > 10" class="mt-1" :pagination="pagination"
                      :counter-label="$t('backup.tabs.log')"
                      @page-change="onPaginationPage" @size-change="onPaginationSize"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import mixinBackupTable from '@/components/mixin/mixinBackupTable'
import { KIND_ICONS } from '@/components/mixin/mixinBackup'
import TablePagination from '@/components/widget/TablePagination.vue'
import BackupTableState from '@/components/partial/backup/BackupTableState.vue'

export default {
  name: 'BackupRestoreLogTable',
  components: { TablePagination, BackupTableState },
  mixins: [mixinBackupTable],
  data: () => ({
    defaultSortField: 'time',
  }),
  computed: {
    ...mapGetters('data', ['getUserAcronyms']),
    fields() {
      return [
        { key: 'time', label: this.$t('backup.columns.time'), sortable: true },
        { key: 'userId', label: this.$t('backup.columns.restoredBy'), sortable: true },
        { key: 'kind', label: this.$t('backup.columns.kind'), sortable: true },
        { key: 'backupId', label: this.$t('backup.columns.backupToCurrent') },
        { key: 'clientId', label: this.$t('backup.columns.client') },
        { key: 'options', label: this.$t('backup.columns.options') },
        { key: 'result', label: this.$t('backup.columns.result'), sortable: true },
        { key: 'message', label: this.$t('backup.columns.message') },
      ]
    },
  },
  methods: {
    ...mapActions('backup', ['getAllBackupRestoreLog']),
    fetchRows(params) {
      return this.getAllBackupRestoreLog(params)
    },
    kindIcon(kind) {
      return `${KIND_ICONS[kind] || 'fa-solid fa-circle'} mr-50`
    },
    otherOptions(options) {
      const out = {}
      Object.keys(options || {}).forEach(k => {
        if (k !== 'applyToBalance' && options[k] != null && typeof options[k] !== 'object') out[k] = options[k]
      })
      return out
    },
  },
}
</script>
